import { Inject, MiddlewareConsumer, Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { QueueUIModule } from './bull-board/queue-ui.module';
import { WareHouseSampleModule } from './warehouse/processor/warehouse-sample.module';
import Arena from 'bull-arena';
import Bull  from "bull";
import { BullArenaUIProvider } from './bull-board/bull-arena-ui-provider';
import { AssetManagementJobQueuesModule } from './asset-management/asset-mgmt.module';

@Module({
  imports: [
    WareHouseSampleModule,
    AssetManagementJobQueuesModule,
    QueueUIModule
  ],
  controllers: [AppController],
  providers: [AppService,
    BullArenaUIProvider,
    {
      provide: 'arenaQueues',
      useFactory: async (arenaService: BullArenaUIProvider) => arenaService.createArenaQueues(),
      inject: [BullArenaUIProvider],
    }],
})
export class AppModule {
  constructor(@Inject('arenaQueues') private queues) { }
  configure(consumer: MiddlewareConsumer) {
    // Now, you can use the asynchronously created this.queues here
    const arena = Arena({ Bull, queues: this.queues }, { disableListen: true });
    consumer.apply(arena).forRoutes('/arena/dashboard');
  }
}
